export default __webpack_public_path__ + "static/media/start-disable.1f5ee628.svg";